var _rect, _rect2, _rect3, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorageAudio(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 7.5,
    fill: "#F6F7F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 7.5,
    stroke: "#E1E1E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#9B5AF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4436 19.5061V14.5406L18.6579 17.0233L15.4436 19.5061Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3972 14.4473C15.4343 14.4301 15.4783 14.435 15.5105 14.4598L18.7248 16.9426C18.7502 16.9622 18.765 16.9919 18.765 17.0233C18.765 17.0548 18.7502 17.0845 18.7248 17.1041L15.5105 19.5869C15.4783 19.6117 15.4343 19.6166 15.3972 19.5993C15.36 19.5821 15.3364 19.5459 15.3364 19.5061V14.5406C15.3364 14.5008 15.36 14.4646 15.3972 14.4473ZM15.5507 14.7558V19.2909L18.4863 17.0233L15.5507 14.7558Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageAudio);
export default __webpack_public_path__ + "static/media/storageAudio.a8c87697625098fe7ba31b1e8777a0c7.svg";
export { ForwardRef as ReactComponent };